import { render } from "./ModalCodeVerify.vue?vue&type=template&id=0ca4919c&scoped=true"
import script from "./ModalCodeVerify.vue?vue&type=script&lang=js"
export * from "./ModalCodeVerify.vue?vue&type=script&lang=js"

import "./ModalCodeVerify.vue?vue&type=style&index=0&id=0ca4919c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca4919c"]])

export default __exports__